import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';
import tokenHeader from '../token-header';

const API_URL = baseUrl()+"/api/all/";

const getDataPesertaSertifikasiRpl = 'data-peserta/data-peserta-sertifikasi-rpl';
const getKategoriPesertaRpl = 'sertifikasi-rpl-select';
const getDataPesertaSertifikasiRplMataUji = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta'
const prosesAdministrasiPesertaRpl = 'data-peserta/sertifikasi-peserta-rpl/proses-administrasi/';
const detailDataPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-rpl';
const putStatusRefundMataUjiPeserta = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta/refund/';
const putStatusPembatalan = 'data-peserta/data-peserta-rpl/edit-status-pembatalan/';
const getRescheduleMataUjiPeserta = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta/reschedule/';
const putKehadiran = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta/kehadiran/';
const putStatusKehadiran = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta/kehadiran/';

class DataPesertaRpl {
    
    getKategoriPesertaRpl() {
        return axios.get(API_URL + getKategoriPesertaRpl, {
            headers: authHeader()
        });
    }

    getDataPeserta(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi_rpl,
        status_pembayaran,
        tahun_daftar,        
    ) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            id_sertifikasi_rpl : id_sertifikasi_rpl,
            status_pembayaran : status_pembayaran,
            periode : tahun_daftar
        }

        return axios.get(
            API_URL + getDataPesertaSertifikasiRpl, {
                params : data,
                headers: authHeader()
            }
        );
    }

    getDataPesertaSertifikasiRplMataUji(currentPage, pageSize, filter, id_sertifikasi_peserta) {
        return axios.get(API_URL + getDataPesertaSertifikasiRplMataUji + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&idSertifikasiPeserta=' + id_sertifikasi_peserta, {
            headers: authHeader()
        });
    }

    detailDataPeserta(idSertifikasiRplPeserta) {
        var data = {
            idSertifikasiRplPeserta: idSertifikasiRplPeserta
        }
        return axios.get(API_URL + detailDataPeserta, {
            headers: authHeader(),
            params: data
        });
    }

    prosesAdministrasiPesertaRpl(formData) {
        return axios.put(
            API_URL + prosesAdministrasiPesertaRpl + formData.id_sertifikasi_rpl_peserta,
            formData,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } }
        );
    }

    putKehadiran(formData) {
        return axios.put(
            API_URL + putKehadiran + formData.id_mata_uji_peserta,
            formData,
            { headers: authHeader() 
        });
    }

    putStatusRefundMataUjiPeserta(formData) {
        return axios.put(
            API_URL + putStatusRefundMataUjiPeserta + formData.id_mata_uji_peserta,
            formData,
            { headers: authHeader() 
        });
    }

    putStatusPembatalan(formData) {        
        return axios.put(API_URL + putStatusPembatalan + formData.id_sertifikasi_rpl_peserta, 
            formData,
        {
            headers: authHeader() 
        });
    }

    getDetailReschedule(id) {
        return axios.get(API_URL + getRescheduleMataUjiPeserta + id, {
            headers: authHeader()
        });
    }

    putStatusKehadiran(formKehadiran) {
        return axios.put(API_URL + putStatusKehadiran + formKehadiran.id_mata_uji_peserta, 
            formKehadiran,
            { headers: authHeader() }
        );
    }

}

export default new DataPesertaRpl();